import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { withUser } from "@unifiedpatents/sso";
import Landscape from "./landscape/landscape";
import TitleBox from "./landscape/title-box";
import { sortBy } from "lodash";
import { LANDSCAPE_DEFAULTS, LANDSCAPE_DEFAULT_URL } from "../../helpers/defaults";

const { filters: DEFAULT_FILTERS_MAP, fields: DEFAULT_FIELDS_MAP, docsUrl: DOCS_URL, versionsPublic } = LANDSCAPE_DEFAULTS.hevc;
const VERSIONS = sortBy(Object.keys(DEFAULT_FILTERS_MAP));

class HEVCLandscape extends Component {
  render() {
    const helmet = {
      title: "HEVC Landscape",
      meta: [
        { name: "keywords", content: "patent landscape, standard essential patent, SEP, royalty rate, RAND, FRAND, HEVC, H.265, licensing, high efficiency video coding" },
        { name: "description", content: "The only HEVC SEP patent landscape that uses objective measures to train a semantic algorithm." }
      ]
    };
    const {
      status: { isLoggedIn, isAdmin },
      metadata
    } = this.props.user;
    const accessLevel =
      metadata.authorization.roles.indexOf("member-hevc-landscape") >= 0
        ? "full"
        : metadata.authorization.roles.indexOf("member-hevc-landscape-trial") >= 0
        ? "trial"
        : isLoggedIn
        ? "guest"
        : "public";
    const { version } = this.props.params;
    const versionsAllowed = isAdmin ? VERSIONS : versionsPublic;
    const title = (
      <TitleBox
        standards={["hevc", "avc", "vvc"]}
        standardCurrent="hevc"
        onStandardChange={val => this.props.router.push({ pathname: `/standards/opal/${val}` })}
        text="MPEG"
        methodologyLink={DOCS_URL}
        versionHidden={true}
        currentVersion={version}
        versionOptions={versionsAllowed}
        versionDisabled={accessLevel !== "full"}
        onVersionChange={this.handleVersionChange}
      />
    );
    return (
      <Fragment>
        <Helmet {...helmet} />
        <Landscape
          accessLevel={accessLevel}
          title={title}
          esUrl={LANDSCAPE_DEFAULT_URL}
          version={DEFAULT_FIELDS_MAP[version]}
          defaultFilters={DEFAULT_FILTERS_MAP[version]}
          key={version}
        />
      </Fragment>
    );
  }

  handleVersionChange = val => {
    this.props.router.push({
      pathname: `/standards/opal/hevc/${val}`,
      query: DEFAULT_FILTERS_MAP[val]
    });
  };
}

export default withUser(HEVCLandscape);
